module.exports = __webpack_public_path__ + "img/Home4.71f08f0c.png";